import React , { Component } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import AUX from '../../hoc/Aux_';
import { connect } from 'react-redux';
import { withRouter, Redirect } from "react-router";
import _ from 'lodash';

class Kugicatdetail extends Component {

  constructor(props) {
    super(props);
    this.state = {
      totalSales: 0,
      catId: this.props.id,
      category: this.props.category,
      catnya: []
    };
  }

  componentWillMount(){

    if(!this.state.category){
      this.props.history.push('kugi');
    }
  }

  renderCat = (e)=>{
    console.log(e);
    return (
      <TableBody  >
      <TableRow key={1}  >
        <TableCell component="th" scope="row" style={{ width: 300 }}>
          Kode
        </TableCell>
        <TableCell align="">{e.featureCatalogCode.replace("@en", "")}</TableCell>
      </TableRow>
      <TableRow key={2}>
        <TableCell component="th" scope="row">
          Nama
        </TableCell>
        <TableCell align="">{e.name.replace("@en", "")}</TableCell>
      </TableRow>
      <TableRow key={5}>
        <TableCell component="th" scope="row">
          Cakupan
        </TableCell>
        <TableCell align="">{e.scope.replace("@en", "")}</TableCell>
      </TableRow>
      <TableRow key={5}>
        <TableCell component="th" scope="row">
          Lingkup Penggunaan
        </TableCell>
        <TableCell align="">{e.fieldOfApplication.replace("@en", "")}</TableCell>
      </TableRow>
      <TableRow key={5}>
        <TableCell component="th" scope="row">
          Nomor Versi
        </TableCell>
        <TableCell align="">{e.versionNumber.replace("@en", "")}</TableCell>
      </TableRow>
      <TableRow key={5}>
        <TableCell component="th" scope="row">
          Tanggal Versi
        </TableCell>
        <TableCell align="">{e.versionDate.replace("@en", "")}</TableCell>
      </TableRow>
      <TableRow key={5}>
        <TableCell component="th" scope="row">
          Nama Organisasi
        </TableCell>
        <TableCell align="">{e.organisationName.replace("@en", "")}</TableCell>
      </TableRow>

      </TableBody>
    )
  }

  render(){
    let listnya = _.filter(this.state.category, item => item.id === `${this.state.catId}@en`);
    console.log(listnya);
    return (
      <AUX>
        <section className="sections" style = {{paddingTop:"5%"}}>
          <div className="container">
            <div className="row justify-content-center" >
            <div>
            <TableContainer component={Paper}>
              <Table aria-label="simple table">

                  {listnya.map(this.renderCat)}
              </Table>
          </TableContainer>
          </div>

          </div>
          </div>
          </section>

        </AUX>

    )
  }
}


const mapStatetoProps = state => {

    return {
        category: state.category
    };
}


export default withRouter(connect(mapStatetoProps)(Kugicatdetail));
